import get from 'lodash.get';

export const selectCountries = state => get(state, 'models.countries.data');
export const selectCountryOptions = state =>
  selectCountries(state).map(({ name, code }) => ({ label: name, value: code }));
